import { useState, useCallback, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.scss";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  // Memoized form validation
  const isFormValid = useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) && password.length >= 6;
  }, [email, password]);

  // Memoized button disabled state
  const isButtonDisabled = useMemo(() => {
    return !isFormValid || isLoading;
  }, [isFormValid, isLoading]);

  // Handle form submission with validation
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setError("");
      setIsLoading(true);

      //
      try {
        const api = process.env.REACT_APP_API_URL;
        if (email && password) {
          try {
            const res = await fetch(`${api}/login/adm`, {
              method: "post",
              credentials: "include",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email, password }),
            });
            if (!res.ok) {
              setError("Invalid credentials");
              return;
            }
            navigate("/admin");
          } catch (err) {
            console.log(err)
            setError("Invalid credentials");
          }
          // Redirect to admin panel on successful login
        } else {
          setError("Invalid credentials");
        }
      } catch (err) {
        setError("Login failed. Please try again.");
      } finally {
        setIsLoading(false);
      }
    },
    [email, password, navigate]
  );

  // Handle back to home navigation
  const handleBackHome = useCallback(() => {
    navigate("/");
  }, [navigate]);

  return (
    <div className="container">
      {/* Login Card */}
      <form className="login-card" onSubmit={handleSubmit}>
        {/* Header with icon */}
        <div className="header-login">
          <div className="icon">
            <i className="ri-admin-line text-3xl text-white"></i>
          </div>
          <h1>Admin Login</h1>
          <p className="subtitle">
            Enter your credentials to access the admin panel
          </p>
        </div>

        {/* Form fields */}
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            id="email"
            type="email"
            placeholder="admin@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        {/* Error message */}
        {error && <p className="error-message">{error}</p>}

        {/* Sign in button */}
        <button type="submit" className="login-btn" disabled={isButtonDisabled}>
          {isLoading ? "Signing in..." : "Sign In"}
        </button>

        {/* Back to home link */}
        <Link to="/" className="back-link" onClick={handleBackHome}>
          ← Back to Home
        </Link>
      </form>
    </div>
  );
}
